/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiCrossRefPackageTypeCode.ts    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-cross-ref-package-type-code";

export class AutogenModelEdiCrossRefPackageTypeCode<RowType extends ModelRow> extends Endpoint<RowType, RowEdiCrossRefPackageTypeCodeFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiCrossRefPackageTypeCode extends ModelRow<RowEdiCrossRefPackageTypeCodeFields> {
	constructor(values?: Partial<RowEdiCrossRefPackageTypeCodeFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiCrossRefPackageTypeCodeFields {
	"code.add_timestamp": Date;
	"code.add_userid": string;
	"code.company_id": string;
	"code.edi_standard_code": string;
	"code.field_code": string;
	"code.field_code_desc": string;
	"code.field_name": string;
	"code.field_table_alias": string;
	"code.mod_timestamp": Date;
	"code.mod_userid": string;
	company_id: string;
	edi_code: string;
	equipment_type_id: string;
	fgi_packaging_type_code: string;
	hdr_uid: number;
	id: string;
	la_business_unit: string;
	order_type_id: string;
	partner_id: string;
	revenue_code_id: string;
	seg_alloc_code: string;
	version: string;
}

